<template>
    <div class="delta-view">
        <div v-if="changes.length === 0">No changes detected.</div>
        <ul v-else>
            <li v-for="change in changes" :key="change.key">
                <div class="input">
                    <label>{{ field(change.key) }}</label>
                </div>
                <div class="previous-value">{{ change.previous }}</div>
                <div class="current-value">{{ change.current }}</div>
            </li>
        </ul>
    </div>
</template>
<script>
function getChanges(previous, current) {
    const keys = new Set()
    const changes = []

    if (!!current) {
        Object.keys(current).forEach(key => {
            keys.add(key)

            const previousValue = JSON.stringify(previous?.[key] || null)
            const currentValue = JSON.stringify(current[key] || null)

            if (previousValue !== currentValue) {
                changes.push({ key: key, previous: previous[key], current: current?.[key] })
            }
        })
    }

    if (!!previous) {
        Object.keys(previous).forEach(key => {
            if (keys.has(key) || previous[key] === null) {
                return
            }

            changes.push({ key: key, previous: null, current: current[key] })
        })
    }

    return changes
}
export default {
    props: {
        previous: {
            type: [Object, Array],
        },
        current: {
            type: [Object, Array],
        },
        fields: {
            type: Object,
        },
        deltaView: {
            type: Object,
        },
    },
    computed: {
        changes() {
            return this.deltaView?.changes ? this.deltaView.changes : getChanges(this.previous, this.current)
        },
    },
    methods: {
        field(key) {
            return this.fields?.[key] || key
        },
    },
}
</script>
<style>
.delta-view {
    .previous-value {
        background-color: #ffebe6;
    }

    .current-value {
        background-color: #e3fcef;
    }
}
</style>
